import { type PropsWithChildren } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { CMS_CDN } from '@/consts/env';
import { useLocale } from '@/hooks';
import { ZepQuizBizLogo } from './ZepQuizBizLogo';
export const BizReview = () => {
  const {
    t
  } = useTranslation(['bizLanding']);
  const {
    locale
  } = useLocale();
  const REVIEWS = [{
    name: t('biz-landing.review1.name'),
    from: t('biz-landing.review1.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/Wk5/lKUY83wK87duEDAq2XzFWk5/en-US/1/profile1.webp`,
    content: <Trans t={t} i18nKey="biz-landing.review1.content" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('biz-landing.review2.name'),
    from: t('biz-landing.review2.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/QFZ/I4bA93wK87cuEDAq2TZhQFZ/en-US/1/profile2.webp`,
    content: <Trans t={t} i18nKey="biz-landing.review2.content" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('biz-landing.review3.name'),
    from: t('biz-landing.review3.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/Y4y/m1Xfc3wK87duEDAq2YhSY4y/en-US/1/profile3.webp`,
    content: <Trans t={t} i18nKey="biz-landing.review3.content" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('biz-landing.review4.name'),
    from: t('biz-landing.review4.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/bP3/C1EgY3wK87duEDAq2HRLbP3/en-US/1/profile4.webp`,
    content: <Trans t={t} i18nKey="biz-landing.review4.content" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('biz-landing.review5.name'),
    from: t('biz-landing.review5.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/OTB/TOgHS3wK87cuEDAvNMCWOTB/en-US/1/profile5.webp`,
    content: <Trans t={t} i18nKey="biz-landing.review5.content" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('biz-landing.review6.name'),
    from: t('biz-landing.review6.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/EXY/6UFDC3wK87duEDAvNKzPEXY/en-US/1/profile6.webp`,
    content: <Trans t={t} i18nKey="biz-landing.review6.content" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('biz-landing.review7.name'),
    from: t('biz-landing.review7.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/sR1/htyUS3wK87duEDAvNKo4sR1/en-US/1/profile7.webp`,
    content: <Trans t={t} i18nKey="biz-landing.review7.content" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('biz-landing.review8.name'),
    from: t('biz-landing.review8.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/0uy/N2cMu3wK87cuEDAvNNuC0uy/en-US/1/profile8.webp`,
    content: <Trans t={t} i18nKey="biz-landing.review8.content" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('biz-landing.review9.name'),
    from: t('biz-landing.review9.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/sE7/diLbK3wK87cuEDAvNM5osE7/en-US/1/profile9.webp`,
    content: <Trans t={t} i18nKey="biz-landing.review9.content" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('biz-landing.review10.name'),
    from: t('biz-landing.review10.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/Qez/4rnIZ3wK87cuEDAq2YdqQez/en-US/1/profile10.webp`,
    content: <Trans t={t} i18nKey="biz-landing.review10.content" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('biz-landing.review11.name'),
    from: t('biz-landing.review11.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/6Tg/obfb83wK87duEDAq2YOV6Tg/en-US/1/profile11.webp`,
    content: <Trans t={t} i18nKey="biz-landing.review11.content" components={{
      Strong: <StrongText />
    }} />
  }, {
    name: t('biz-landing.review12.name'),
    from: t('biz-landing.review12.from'),
    avatarSrc: `${CMS_CDN}/medias/9z7bCJzn/cFM/nmOAm3wK87cuEDAq2VpYcFM/en-US/1/profile12.webp`,
    content: <Trans t={t} i18nKey="biz-landing.review12.content" components={{
      Strong: <StrongText />
    }} />
  }];
  return <section className="flex flex-col items-center gap-2xl px-[16px] py-2xl min-[751px]:px-[24px] min-[1025px]:gap-3xl min-[1025px]:px-[40px] min-[1025px]:py-3xl" data-sentry-component="BizReview" data-sentry-source-file="BizReview.tsx">
      <div className="flex flex-col items-center gap-sm">
        <div className="flex flex-wrap items-center justify-center gap-sm text-center text-display-sm-extrabold text-default min-[751px]:whitespace-normal">
          <p>{t('biz-landing.hr.title1')}</p>
          <div className="flex items-center gap-sm">
            <ZepQuizBizLogo className="relative bottom-[2px]" data-sentry-element="ZepQuizBizLogo" data-sentry-source-file="BizReview.tsx" />
            {locale === 'ko' || locale === 'ja' ? t('biz-landing.hr.josa') : '?'}
          </div>
          {(locale === 'ko' || locale === 'ja') && <p>{t('biz-landing.hr.title2')}</p>}
        </div>

        <p className="text-body-lg-semibold text-neutral">
          {t('biz-landing.review.description')}
        </p>
      </div>

      <div className="relative h-[774px] w-full max-w-[1280px] overflow-y-hidden">
        <div className="columns-1 gap-[24px] min-[751px]:columns-3 min-[1025px]:columns-4">
          {REVIEWS.map(review => <ReviewCard key={review.name} {...review} />)}
        </div>
        <div className="absolute bottom-0 h-[100px] w-full bg-gradient-to-b from-[rgba(255,255,255,0)] to-white" />
      </div>
    </section>;
};
export const ReviewCard = ({
  name,
  from,
  avatarSrc,
  content
}: {
  name: string;
  from: string;
  avatarSrc: string;
  content: JSX.Element;
}) => {
  return <figure className="mx-auto mb-md flex w-full max-w-[500px] break-inside-avoid flex-col gap-md rounded-md border border-alternative px-md py-lg shadow-sm min-[751px]:mb-[24px] min-[751px]:gap-lg min-[751px]:px-lg min-[751px]:py-xl" data-sentry-component="ReviewCard" data-sentry-source-file="BizReview.tsx">
      <figcaption className="flex items-center gap-xs" data-sentry-element="figcaption" data-sentry-source-file="BizReview.tsx">
        <img src={avatarSrc} alt={from} className="size-[36px]" loading="lazy" />
        <div className="flex flex-col gap-4xs">
          <span className="text-caption-md-medium text-neutral">{from}</span>
          <span className="text-body-sm-semibold text-neutral">{name}</span>
        </div>
      </figcaption>

      <blockquote className="text-body-lg-medium text-neutral">
        {content}
      </blockquote>
    </figure>;
};
const StrongText = ({
  children
}: PropsWithChildren) => <strong className="text-body-lg-bold text-default" data-sentry-component="StrongText" data-sentry-source-file="BizReview.tsx">{children}</strong>;